console.log("text-highlighter.js loaded");

(() => {
  // Phrases to highlight (add to this over time)
  const RULES = [
    { phrase: "OHS-Approved", className: "highlight-text", hyphenSafe: true },
    { phrase: "Melbourne", className: "highlight-text"},
    { phrase: "Specialist Safety", className: "highlight-text"},
    { phrase: "safety responsibilities.", className: "highlight-text"},
    { phrase: "FitSafe", className: "highlight-text"},
    { phrase: "work?", className: "highlight-text"},
    { phrase: "benefit", className: "highlight-text"},
    { phrase: "massive", className: "highlight-text"},
    { phrase: "Independent", className: "highlight-text"},
    { phrase: "Multi-site", className: "highlight-text", hyphenSafe: true },
    { phrase: "Apartment & hotel", className: "highlight-text"},
    { phrase: "Boutique", className: "highlight-text"},
    { phrase: "Boxing & martial arts", className: "highlight-text"},
    { phrase: "safety compliant.", className: "highlight-text"},
    { phrase: "Safety Audits", className: "highlight-text"},
    { phrase: "gym safety?", className: "highlight-text"},
    { phrase: "audit process", className: "highlight-text"},
    { phrase: "after the audit", className: "highlight-text"},
    { phrase: "facilities", className: "highlight-text"},
    { phrase: "Ongoing", className: "highlight-text"},
    { phrase: "Support Services", className: "highlight-text"},
    { phrase: "fix them properly.", className: "highlight-text"},
    { phrase: "implementation support?", className: "highlight-text"},
    { phrase: "after implementation?", className: "highlight-text"},
    { phrase: "walk away", className: "highlight-text"},
    { phrase: "Australia.", className: "highlight-text"},
  ];

  // Only run on h1, h2 across the entire site
  const TARGET_SELECTOR = "h1, h2";

  function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function buildRegex(rule) {
    let p = escapeRegExp(rule.phrase);
    if (rule.hyphenSafe) p = p.replace(/\\-/g, "[-–—]");
    if (rule.wholeWord) p = `\\b${p}\\b`;
    return new RegExp(`(${p})`, "gi");
  }

  const compiled = RULES.map((r) => ({ ...r, regex: buildRegex(r) }));

  const combined = new RegExp(
    `(${compiled.map((r) => r.regex.source.replace(/^\(|\)$/g, "")).join("|")})`,
    "gi"
  );

  function highlightElement(el) {
  if (!el || el.nodeType !== 1) return;
  if (el.dataset && el.dataset.hlDone === "1") return;

  // Skip blog post headings entirely
  if (
    el.closest(".blog-post-template") ||
    el.closest(".blog-post-main__content") ||
    el.closest(".blog-post-hero")
  ) {
    return;
  }

  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
  const nodes = [];

  while (walker.nextNode()) {
    const n = walker.currentNode;
    const v = n.nodeValue;
    if (!v) continue;

    combined.lastIndex = 0;
    if (combined.test(v)) nodes.push(n);
  }

  nodes.forEach((textNode) => {
    const text = textNode.nodeValue;
    if (!text) return;

    combined.lastIndex = 0;
    if (!combined.test(text)) return;

    const parts = text.split(combined);
    if (parts.length === 1) return;

    const frag = document.createDocumentFragment();

    parts.forEach((part) => {
      if (!part) return;

      const rule = compiled.find((r) => {
        r.regex.lastIndex = 0;
        const m = part.match(r.regex);
        return m && m[0] === part;
      });

      if (rule) {
        const span = document.createElement("span");
        span.className = rule.className || "highlight-text";
        span.textContent = part;
        frag.appendChild(span);
      } else {
        frag.appendChild(document.createTextNode(part));
      }
    });

    textNode.parentNode.replaceChild(frag, textNode);
  });

  if (el.dataset) el.dataset.hlDone = "1";
}

  function run(scope = document) {
    scope.querySelectorAll(TARGET_SELECTOR).forEach(highlightElement);
  }

  // Initial run
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => run(document));
  } else {
    run(document);
  }

  // Shopify editor reloads
  document.addEventListener("shopify:section:load", (e) => run(e.target));

  // Catch late-injected content
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        run(node);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
